var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03636 11.8181C6.41212 11.8181 5.0303 11.2545 3.89091 10.1272C2.75152 8.99994 2.18182 7.62419 2.18182 5.99994V5.87267L1.01818 7.03631L0 6.01813L2.90909 3.10904L5.81818 6.01813L4.8 7.03631L3.63636 5.87267V5.99994C3.63636 7.21207 4.06364 8.24237 4.91818 9.09085C5.77273 9.93934 6.81212 10.3636 8.03636 10.3636C8.35152 10.3636 8.66061 10.3272 8.96364 10.2545C9.26667 10.1818 9.56364 10.0727 9.85455 9.92722L10.9455 11.0181C10.4848 11.2848 10.0121 11.4848 9.52727 11.6181C9.04243 11.7515 8.54545 11.8181 8.03636 11.8181ZM13.0909 8.89085L10.1818 5.98176L11.2 4.96358L12.3636 6.12722V5.99994C12.3636 4.78782 11.9364 3.75752 11.0818 2.90904C10.2273 2.06055 9.18788 1.63631 7.96364 1.63631C7.64848 1.63631 7.33939 1.67267 7.03636 1.7454C6.73333 1.81813 6.43636 1.92722 6.14545 2.07267L5.05455 0.981763C5.51515 0.715096 5.98788 0.515096 6.47273 0.381763C6.95758 0.248429 7.45455 0.181763 7.96364 0.181763C9.58788 0.181763 10.9697 0.745399 12.1091 1.87267C13.2485 2.99994 13.8182 4.3757 13.8182 5.99994V6.12722L14.9818 4.96358L16 5.98176L13.0909 8.89085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b0a11731d039d5cbd76c4297d2313772.svg";
export { ForwardRef as ReactComponent };